import FieldWrapper from './field-wrapper';
import { useController, UseControllerProps, FieldValues, Path, PathValue } from 'react-hook-form';
import { RadioInput, RadioOption } from 'shared/ui/controls';

type FieldValue<T extends FieldValues, K extends Path<T>> = PathValue<T, K>;

export interface RadioInputFieldProps<T extends FieldValues, K extends Path<T> = Path<T>>
  extends UseControllerProps<T> {
  label?: string;
  required?: boolean;
  additionalClass?: string;
  direction?: 'horizontal' | 'vertical';
  isSmallSize?: boolean;
  options: RadioOption<FieldValue<T, K>>[];
  name: K;
  disabled?: boolean;
}

export const RadioInputField = <T extends FieldValues, K extends Path<T>>({
  label,
  required,
  additionalClass,
  direction,
  options,
  isSmallSize,
  disabled,
  ...props
}: RadioInputFieldProps<T, K>) => {
  const {
    field,
    fieldState: { error }
  } = useController(props);

  return (
    <FieldWrapper label={label} error={error} required={required}>
      <RadioInput<FieldValue<T, K>>
        additionalClass={additionalClass}
        direction={direction}
        options={options}
        isSmallSize={isSmallSize}
        disabled={disabled}
        {...field}
      />
    </FieldWrapper>
  );
};
